import { merge } from '@oysterjs/core/graphql/loaders';
import { ErrorBoundary } from '@oysterjs/ui/error-boundary';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import {
  loadAgencyUsers,
  loadCurrentUser,
  shouldRevalidateCurrentUser
} from '~/api/data/users/queries';
import { DashboardContainer } from '~/components/dashboard';
import { accountRoutes } from '~/router/app/accounts';
import { callsRoute } from '~/router/app/calls';
import { clientsRoute } from '~/router/app/clients';
import { documentRoutes } from '~/router/app/documents';
import { homeRoute } from '~/router/app/home';
import { knowledgeRoutes } from '~/router/app/knowledge';
import { libraryRoutes } from '~/router/app/library';
import { bulkDraftRoute, legacyEmailsRoute, mailboxRoutes } from '~/router/app/mailbox';
import { policyRoutes } from '~/router/app/policies';
import { presetsRoute } from '~/router/app/presets';
import { servicingRoutes } from '~/router/app/servicing';
import { settingsRoute } from '~/router/app/settings';
import { smartFillRoute } from '~/router/app/smart-fill';
import { workflowRoutes } from '~/router/app/workflows';
import { workspaceRoutes } from '~/router/app/workspaces';

export const appRoute: RouteObject = {
  id: 'app',
  path: 'app',
  loader: merge({
    agencyUser: loadCurrentUser,
    agencyUsers: loadAgencyUsers
  }),
  shouldRevalidate: shouldRevalidateCurrentUser,
  element: <DashboardContainer />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '',
      element: <Navigate to="home" replace />
    },
    homeRoute,
    clientsRoute,
    ...workspaceRoutes,
    ...documentRoutes,
    smartFillRoute,
    presetsRoute,
    ...libraryRoutes,
    ...workflowRoutes,
    callsRoute,
    mailboxRoutes,
    bulkDraftRoute,
    legacyEmailsRoute,
    ...accountRoutes,
    ...policyRoutes,
    ...knowledgeRoutes,
    ...servicingRoutes,
    settingsRoute
  ]
};
